import { useCallback } from 'react'
import { ContentStateInterface, ContentStateProperty, GeoAutocompletionType } from '../../../../@types/types'
import { useStore } from 'react-redux'
import { InitState } from '../../../../redux/reducers/root/initialState'
import { onChangeGeoAutocompletionInput } from '../../../../redux/thunks/geoAutocompletion/geoAutocompletion'
// import { isValidPostcode } from '../../../../services/validation/rules/validationFunctions'
import { useAppDispatch } from '../../../../app/hooks'
import { AddressScreenValidationResult } from '../../../../@types/validation-types'
import { isInvalidPostcode } from '../../../../services/validation/rules/validationFunctions'

export function useDoGeoAutocompletion() {
  const store = useStore<InitState>()
  const dispatch = useAppDispatch()
  return useCallback(
    (property: ContentStateProperty, value: string | undefined, currentInsertionData: ContentStateInterface) => {
      const invalid = store.getState().insertionFeature.validationResult?.address?.fields

      const hasValidationErrors =
        invalid &&
        invalid[property as keyof AddressScreenValidationResult] &&
        invalid[property as keyof AddressScreenValidationResult]!.length > 0

      const isPostcodeInvalid = property !== 'postcode' || !/^\d+$/.test(value!.toString())
      if (isPostcodeInvalid && hasValidationErrors) {
        return
      }

      const geoProperty = property.toUpperCase() as GeoAutocompletionType
      const postcode = currentInsertionData.postcode ? currentInsertionData.postcode.toString() : ''
      const isCompletePostcode =
        postcode.length === 5 && isInvalidPostcode(postcode, 'postcode', currentInsertionData) === undefined

      dispatch(
        isCompletePostcode
          ? onChangeGeoAutocompletionInput(String(value), geoProperty, postcode)
          : onChangeGeoAutocompletionInput(String(value), geoProperty)
      )
    },
    [store, dispatch]
  )
}
